import { render, staticRenderFns } from "./PakamInfoStep.vue?vue&type=template&id=314f3981&scoped=true"
import script from "./PakamInfoStep.vue?vue&type=script&lang=js"
export * from "./PakamInfoStep.vue?vue&type=script&lang=js"
import style0 from "./PakamInfoStep.vue?vue&type=style&index=0&id=314f3981&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314f3981",
  null
  
)

export default component.exports